import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptcha2Component } from 'ngx-captcha';
import { first } from 'rxjs/operators';
import { UserserviceService } from '../userservice.service';
@Component({
  selector: 'app-boardlogin',
  templateUrl: './boardlogin.component.html',
  styleUrls: ['./boardlogin.component.scss']
})
export class BoardloginComponent implements OnInit {

  loginform!: FormGroup;
  loginuser: any;

  @ViewChild('captchaElem')
  captchaElem!: ReCaptcha2Component ;
  @ViewChild('langInput')
  langInput!: ElementRef;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;

  // username: any;
  role: any;
  // siteKey: string="6LeCIYseAAAAAIvHzxeyoDYs8BJa-xEjVhxKa-yM";
  //siteKey: string="6LfyorAeAAAAAG8BJ3HrLP-HPHNWWO45JzKJd4nN";
  siteKey: string="6Lfp7uYkAAAAACIGySKyhivHiPkHw3myco8BFBn8";
  Requestform: any;
  loading = false;
  submitted = false;

  loginusername!:any;
  loginuserpass!:any;
  loginfail:boolean=false;
  typetext1!:boolean;
  loggeduser="";
  constructor(public fb:FormBuilder, private router: Router, private route: ActivatedRoute,private formBuilder: FormBuilder, private service:UserserviceService) {
  }
  ngOnInit(): void { 
    if(sessionStorage.getItem('roleid')=="2"){      
      if(sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")!=null){
        alert("You Have already logged in... \nPlease log off to login with different id! ")
        this.router.navigate(['/dashboard']);

        // sessionStorage.clear();
       }
      }
    this.Requestform = this.formBuilder.group({
    
      username: ['', Validators.required],
      password: ['', Validators.required],
      recaptcha: ['', Validators.required]
    });

  }
  get f() { return this.Requestform.controls; }


 
  onSubmit(form:any ){

    this.submitted = true;
    if (this.Requestform.invalid) {
      return;
    }
    this.loginusername=this.Requestform.value.username;
    this.loginuserpass=this.Requestform.value.password;
    this.boardlogin();
  }
   
  resetF(){
    this.submitted=false;
    // this.Requestform.recaptcha.reset();
  }
  show_hide_password1(){
    this.typetext1 =!this.typetext1;
  }
  hidewarningmsg(){
    this.loginfail=false;
  }
boardlogin(){   
  let logindetail :{email_address:any, password:any}={
    email_address:this.loginusername,
    password:this.loginuserpass,
};
this.service.post('/Student_module/logincheck',logindetail).subscribe((res:any)=>{
    console.log(res);
    if(res.status=="success"){
      if(res.Data[0].role_id=="2" || res.Data[0].role_id=="3"){
         sessionStorage.setItem('loggeduser','boardadmin');
         sessionStorage.setItem('loggeduserid',res.Data[0].username);
         sessionStorage.setItem('roleid',res.Data[0].role_id);

        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
                      this.router.navigateByUrl(returnUrl).then(() => {
                        window.location.reload();
                        });
      }
      else{
        alert("This portal is for Board use")
        window.location.reload();
      }

    }
    else{
      alert(res.Data);
      window.location.reload();
      // this.Requestform.reset();
      // this.submitted = false;
    }
  });
}
gotoresetpassword(){
  this.router.navigate(['/resetpassword','boardadmin'], {
    skipLocationChange: true,
  });
}
  
}
